var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.is_mem_load
    ? _c("div", [
        _c("div", { staticClass: "intro" }, [
          _c("legend", [_vm._v(_vm._s(this.mem_type))]),
          _vm._v(" "),
          _c("div", { staticClass: "memorandum_info row" }, [
            _c(
              "div",
              { staticClass: "col-lg-6 col-sm-12" },
              [
                _c("mem_block_left", {
                  on: {
                    edit_links: _vm.edit_links,
                    edit_title: function ($event) {
                      return _vm.edit_text("mem_title")
                    },
                  },
                }),
                _vm._v(" "),
                _c("mem_links_edit"),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-lg-6 col-sm-12 right_no_form_style" },
              [_c("mem_block_right")],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "memorandum_work_block memorandum_info" }, [
          _c(
            "div",
            { staticClass: "memorandum_info dani" },
            [
              _c("legend", [_vm._v("Данi")]),
              _vm._v(" "),
              _c("mem_text", {
                key: "pre_text",
                attrs: { label: "Преамбула", text: _vm.mem_pre },
                on: {
                  edit_text: function ($event) {
                    return _vm.edit_text("mem_pre")
                  },
                },
              }),
              _vm._v(" "),
              _c("mem_text", {
                key: "problem",
                attrs: { label: "Проблема", text: _vm.mem_problem },
                on: {
                  edit_text: function ($event) {
                    return _vm.edit_text("mem_problem")
                  },
                },
              }),
              _vm._v(" "),
              _c("mem_text", {
                key: "result",
                attrs: { label: "Запропоноване рішення", text: _vm.mem_result },
                on: {
                  edit_text: function ($event) {
                    return _vm.edit_text("mem_result")
                  },
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        this.memorandum.hasOwnProperty("addon_data")
          ? _c(
              "div",
              { staticClass: "addon_data" },
              [
                _c(_vm.cur_addon_component, {
                  tag: "component",
                  attrs: {
                    addon_data: _vm.memorandum.addon_data,
                    mem: _vm.memorandum,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }